'use client';

import React, { FC } from 'react';

import { Box, Image } from '@mantine/core';

import cx from './ScrollingImage.module.css';

const ScrollingImage: FC<{
    image: {
        src: string;
        width: number;
        height: number;
    };
    aspectRatio?: number;
    autoplay?: boolean;
}> = ({ image, aspectRatio = 1, autoplay = false }) => (
    <Box
        className={cx.wrapper}
        style={{
            '--aspect-ratio': aspectRatio,
            '--image-width': `${image.width}`,
            '--image-height': `${image.height}`,
            '--image-animation-duration': `${(image.height / image.width) * 6}s`,
        }}
        data-autoplay={autoplay}
    >
        <Image src={image.src} width={image.width} height={image.height} alt="" />
    </Box>
);
export { ScrollingImage };
